import { ValidatorFn, Validators } from '@angular/forms';
import { PolicyModels, QuotationModels } from '@wz-models';
import { WzDateValidators } from '@wz-validators';
import { subDays, subYears } from 'date-fns';

export const getMinMaxAgeByPackage = (
  pck: PolicyModels.PackageEnum,
  formula: QuotationModels.FormulaEnum,
): { minAge: number; maxAge: number } => {
  let minAge: any, maxAge: any;

  const formulasWith80YearOld = [
    QuotationModels.FormulaEnum.Sante5,
    QuotationModels.FormulaEnum.Sante6,
    QuotationModels.FormulaEnum.Sante7,
  ];

  switch (pck) {
    case PolicyModels.PackageEnum.Sante_InfinitySante:
      minAge = 18;
      maxAge = 90;
      break;
    case PolicyModels.PackageEnum.Sante_Acheel:
      minAge = 30;
      maxAge = 90;
      break;
    case PolicyModels.PackageEnum.Sante_Fidelity: {
      minAge = 50;
      maxAge = 90;

      if (formulasWith80YearOld.indexOf(formula) >= 0) {
        maxAge = 90;
      }
      break;
    }
    default:
      minAge = null;
      maxAge = null;
      break;
  }
  return { minAge, maxAge };
};

export const factoryAgeValidators = (
  dateEffet: Date,
  minAge: number,
  maxAge: number,
): ValidatorFn[] => {
  const validators = [Validators.required];

  if (!dateEffet) {
    return validators;
  }

  if (minAge != null) {
    validators.push(
      WzDateValidators.max(subDays(subYears(dateEffet, minAge), 1)),
    );
  }

  if (maxAge != null) {
    validators.push(
      WzDateValidators.min(
        new Date(subYears(dateEffet, maxAge).getFullYear(), 0, 1),
      ),
    );
  }

  return validators;
};

export interface SkillTableItem {
  name: string;
  id: number;
}

// export const getControl = (
//   id: number;

//   formula: QuotationModels.FormulaEnum
// ): { minAge: number; maxAge: number } => {
//   return { minAge, maxAge };
// }

export interface Question {
  Id: number;
  Order: number;
  KeyQ: string;
  Label: string;
  QuestionValue: string;
  DisplayCondition: string;
  Branch: string;
  CurentDisplayed: boolean;
}

export const controlListe: Question[] = [
  {
    Id: 0,
    Order: 0,
    KeyQ: 'CompositionFamiliale',
    Label: 'Composition Familiale',
    QuestionValue: '0', // 1 = Celibataire, 2=Adulte avec Enfant, 3=Couple, 4= Couple avec enfant
    DisplayCondition: 'true',
    Branch: 'Sante1',
    CurentDisplayed: true,
  },
  {
    Id: 1,
    Order: 1,
    KeyQ: 'Sexe',
    Label: 'Sexe',
    QuestionValue: '0', // 2 Homme  1 Femme
    DisplayCondition: 'true', //
    Branch: 'Sante2',
    CurentDisplayed: true,
  },
  {
    Id: 200,
    Order: 200,
    KeyQ: 'NombreEnfants',
    Label: 'Nombre Enfants',
    QuestionValue: '0',
    DisplayCondition:
      '#CompositionFamiliale# == 2 || #CompositionFamiliale# == 4', // ON affiche le nb enfants seulement si  CompositionFamiliale =3 or 4
    Branch: 'Sante2',
    CurentDisplayed: true,
  },
  {
    Id: 2,
    Order: 2,
    KeyQ: 'DateNaissance',
    Label: 'Date Naissance',
    QuestionValue: '0', // 1 Homme  2 Femme
    DisplayCondition: 'true', //
    Branch: 'Sante2',
    CurentDisplayed: true,
  },
  {
    Id: 3,
    Order: 3,
    KeyQ: 'RegimeSocial',
    Label: 'Regime Social',
    QuestionValue: '0',
    DisplayCondition: 'true',
    Branch: 'Sante2',
    CurentDisplayed: true,
  },
  {
    Id: 4,
    Order: 4,
    KeyQ: 'ConjointDateNaissance',
    Label: 'Conjoint Date Naissance',
    QuestionValue: '0',
    DisplayCondition:
      '#CompositionFamiliale# == 3 || #CompositionFamiliale# == 4', //
    Branch: 'Sante2',
    CurentDisplayed: true,
  },
  {
    Id: 5,
    Order: 5,
    KeyQ: 'ConjointRegimeSocial',
    Label: 'Conjoint Regime Social',
    QuestionValue: '0',
    DisplayCondition:
      '#CompositionFamiliale# == 3 || #CompositionFamiliale# == 4', //
    Branch: 'Sante2',
    CurentDisplayed: true,
  },
  {
    Id: 6,
    Order: 6,
    KeyQ: 'EnfantsDateNaissance',
    Label: 'Enfants Date Naissance',
    QuestionValue: '',
    DisplayCondition:
      '#CompositionFamiliale# == 2 || #CompositionFamiliale# == 4',
    Branch: 'Sante2',
    CurentDisplayed: true,
  },
  {
    Id: 7,
    Order: 7,
    KeyQ: 'DateDebutContrat',
    Label: 'Date Debut Contrat',
    QuestionValue: '0',
    DisplayCondition: 'true',
    Branch: 'Sante2',
    CurentDisplayed: true,
  },

  {
    Id: 8,
    Order: 8,
    KeyQ: 'NiveauRemboursement',
    Label: 'Niveau Remboursement',
    QuestionValue: '',
    DisplayCondition: 'true',
    Branch: 'Sante2',
    CurentDisplayed: true,
  },

  {
    Id: 9,
    Order: 9,
    KeyQ: 'NomPrenom',
    Label: 'Nom Prenom',
    QuestionValue: '0',
    DisplayCondition: 'true',
    Branch: 'Sante2',
    CurentDisplayed: true,
  },
  {
    Id: 10,
    Order: 10,
    KeyQ: 'Departement',
    Label: 'Departement',
    QuestionValue: '0',
    DisplayCondition: 'true',
    Branch: 'Sante2',
    CurentDisplayed: true,
  },
  {
    Id: 11,
    Order: 11,
    KeyQ: 'Contact',
    Label: 'Contact',
    QuestionValue: '',
    DisplayCondition: 'true',
    Branch: 'Sante2',
    CurentDisplayed: true,
  },
];
